<template>
  <div class="is-main-content">
    <div class="columns">
      <div class="column ">
        <div>
          <div class="container is-fluid">
            <div class="columns">
              <div class="column is-9-fullhd is-7-desktop is-6-tablet">
                <div class="content">
                  <h3 class="level">Mes opportunités</h3>
                </div>
              </div>
            </div>
          </div>
          <hr>
          <br>
          <div class="container is-fluid">
            <app-liste />
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Liste from './liste';

const User = createNamespacedHelpers('user');

export default {
  name: 'index',
  components: {
    appListe: Liste,
  },
  data() {
    return {
      loadingComponent: false,
    };
  },
  computed: {
    ...User.mapGetters({
      userEmail: 'userEmail',
    }),
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/mesOpportunites/recherche/index.vue